import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';

// mirrors https://prototype.sqprod.co/#/docs/squareup.bills.SquareAccountTender
export default ProtoBaseModel.extend({
  squareAccountToken: attr(String),
  contactToken: attr(String),
  primaryDisplayName: attr(String)
});